import React from 'react'
import PagesHeader from '../common/components/PagesHeader'
import FAQ from '../common/components/FAQ'
import OurMission from './OurMission'
import FullyFeaturedLoans from './FullyFeaturedLoans'
import AwardBadges from '../common/components/AwardBadges'
import AboutUsInfo from './AboutUsInfo'
import CareerOpportunities from './CareerOpportunities'
import PartnersCTA from '../common/components/PartnersCTA'
import TrustPilot from '../common/components/TrustPilot'

function App() {
  return(
    <div>
      <div className="jumbotron jumbotron-fluid jumbotron-fixed-height pb-0 about-us-header">
        <div className="container">
          <PagesHeader
            header="About Yard"
            body="Yard is an Australian mortgage lender, not a bank. We focus on home loans and we're specialists."
          />
        </div>
      </div>
      <OurMission />
      <FullyFeaturedLoans />
      <AboutUsInfo />
      <FAQ />
      <AwardBadges 
        header={
          <div className='award-badges-header'>
            <h3>Our awards!</h3>
            <span>We're an award winning lender!</span>
          </div>
        }
      />
      <CareerOpportunities />
      <TrustPilot 
        templateId='539adbd6dec7e10e686debee' 
        height="500px"
        subHeader="..."
      />
      <PartnersCTA />
    </div>
  )
}

export default App
